export const NAV = [
  { id: "about", label: "About" },
  { id: "models", label: "Engagement" },
  { id: "focus", label: "BFSI & Startups" },
  { id: "talent-map", label: "Talent Map" },
  { id: "process", label: "Process" },
];

export const CLIENTS = [
  "RBL Bank", "Federal Bank", "Kotak Mahindra Bank", "HDFC Bank", "Kotak Securities",
  "Angel Broking", "DCB Bank", "Cholamandalam Finance", "DBS Finance Limited", "Protean E-Gov",
  "Bajaj Finance", "Crisil", "ICICI Prudential Life Insurance", "TCS", "Cmetric",
  "Ford Motors", "Adani Enterprise", "Lotus AMC", "Barclays NBFC", "Vodafone",
];

export const HERO_STATS = [
  { k: "25+", v: "Years of BFSI leadership behind every search" },
  { k: "3", v: "Tiers covered: CXO, senior and mid management" },
  { k: "Pan-India", v: "Reach with regional depth" },
];

export const PILLARS_ABOUT = [
  { t: "Startup with deep roots", d: "Backed by 25+ years of BFSI experience of founder Anuj Saraswat." },
  { t: "Our focus", d: "CXO, senior and mid-management hiring across BFSI, financial services and high-growth startups." },
  { t: "Our approach", d: "Relationship-led search, market insight and disciplined assessment." },
];

export const CAREER = ["Citibank", "RBL Bank", "India Post Payments Bank", "ItzCash / EbixCash", "ICICI Bank", "Hitachi Payment Services", "Reliance Money"];

export const WHY = {
  hero: { k: "25+", t: "Years of BFSI industry experience", d: "Founder-led search. Every mandate is shaped by someone who has run P&Ls, built teams and sat across the table from regulators." },
  network: { t: "A focused BFSI talent network", d: "Active and passive leaders across India and specialist domains: from credit and treasury to payments rails and digital lending." },
  trio: [
    { t: "Deep domain understanding", d: "Banking, financial services, payments and fintech. We speak the language of your business." },
    { t: "Consultative & relationship-led", d: "A partnership, not transactional hiring. We stay with the mandate until the leader settles in." },
    { t: "Strategic advisory", d: "Talent, organisation and leadership counsel, before and beyond the hire." },
  ],
  wide: { t: "Agile & outcome-driven", d: "Engagements built around your hiring needs, not our templates. Speed with quality, measured by the leaders who stay and deliver." },
};

export const BFSI_SEGMENTS = [
  "Retail, corporate & digital banking",
  "NBFC, lending & housing finance",
  "Life & general insurance",
  "Payments, cards & prepaid instruments",
  "Capital markets, broking & AMC",
  "Fintech & financial inclusion",
];

export const STARTUP_SEGMENTS = [
  "First CXO hires: CFO, CTO, COO, CBO",
  "Fundraise-ready finance & investor-relations leaders",
  "Risk, compliance & regulatory heads for licensed fintechs",
  "Scale-up leaders across sales, growth, product & tech",
  "Confidential replacement and succession mandates",
  "Leadership advisory on org design as you scale",
];

export const TALENT_MAP = [
  { tier: "Tier 01", name: "CXO & C-Suite", roles: ["CEO / MD / Country Head", "COO / CFO / CTO / CRO", "CBO / CCO / CHRO", "Business/Unit Heads", "Independent Directors"] },
  { tier: "Tier 02", name: "Senior Management", roles: ["Function Heads", "Business Unit Heads", "Regional Heads", "Program / Project Heads", "Vertical Heads"] },
  { tier: "Tier 03", name: "Mid Management", roles: ["Managers / Assistant Managers", "Deputy Managers", "Senior Analysts / Specialists", "Relationship Managers", "Branch / Operations Managers", "Product / Process Specialists"] },
];

export const SECTORS = ["Banking", "NBFC", "Insurance", "Payments", "Fintech", "Startups"];

export const LENS = [
  { t: "Business acumen", d: "Market dynamics, customer needs and regulation. Leaders who read the business, not just the brief." },
  { t: "Functional & technical depth", d: "Domain expertise, product and digital knowledge, tested against the realities of your function." },
  { t: "Leadership & people impact", d: "Team building, change leadership and an execution mindset that others follow." },
  { t: "Execution & change", d: "Delivery focus, resilience and agility through cycles, audits and transformation." },
  { t: "Cultural & value alignment", d: "Integrity, collaboration and long-term thinking. The fit that outlasts the first hundred days." },
];

export const PROCESS = [
  { t: "Understand", d: "Role definition, expectations, culture and the outcomes the leader must deliver." },
  { t: "Source & engage", d: "Active and passive sourcing, market and competitor talent mapping." },
  { t: "Assess & validate", d: "Structured interviews, reference checks and psychometrics as needed." },
  { t: "Shortlist & present", d: "Detailed profiles with comparative analysis, so you decide with evidence." },
  { t: "Close & onboard", d: "Offer negotiation, notice management and transition support." },
];

export const PROCESS_VALUES = ["Confidentiality", "Efficiency", "Quality focus", "Long-term partnership"];

export const MODELS = [
  { t: "Retained Search", tag: "CXO & critical roles", d: "Exclusive, dedicated ownership of your most sensitive mandates, with a committed search team and structured milestones.", pts: ["Exclusivity & ownership", "Market mapping report", "Board-ready shortlist"] },
  { t: "Contingency Search", tag: "Mid & senior management", d: "Success-based search for mid and senior roles where speed and access to strong pipelines matter most.", pts: ["Success-linked fee", "Fast turnaround", "Pre-assessed profiles"] },
  { t: "Project-based", tag: "Specific or closed mandates", d: "Defined-scope engagements for team build-outs, new business lines, branch expansions or confidential closed roles.", pts: ["Fixed scope & timeline", "Multi-role hiring", "Single point of contact"] },
  { t: "Advisory Support", tag: "Org & leadership", d: "Organisation structure, talent mapping and leadership advisory for boards, founders and HR heads.", pts: ["Org design", "Talent & compensation mapping", "Succession planning"] },
];

export const CONTACT = {
  email: "connect@anwetaventures.com",
  phone: "+91 98192 31656",
  whatsapp: "https://wa.me/919819231656",
  address: "D701, Oberoi Splendor, JVLR, Mumbai - 400060",
};
